export const gradeText = (grade) => {
  if (grade === 21) {
    return "A类";
  } else if (grade === 22) {
    return "B类";
  } else if (grade === 23) {
    return "C类";
  } else if (grade === 24) {
    return "D类";
  } else if (grade === 25) {
    return "E类";
  } else if (grade === 26) {
    return "F类";
  } else if (grade === 63) {
    return "空号";
  } else if (grade === 64) {
    return "停机";
  } else if (grade === 65) {
    return "拒接";
  } else if (grade === 66) {
    return "无法接通";
  } else if (grade === 67) {
    return "占线";
  } else if (grade === 68) {
    return "无人接听";
  } else if (grade === 69) {
    return "正在通话中";
  } else if (grade === 70) {
    return "来电提醒";
  } else if (grade === 79) {
    return "未送达";
  }
  return "未知"
}

export const secondToDate = (msd) => {
  let time = msd;
  if (null != time && "" != time) {
    if (time > 60 && time < 60 * 60) {
      time = parseInt(time / 60.0) + "分" + parseInt((parseFloat(time / 60.0) -
        parseInt(time / 60.0)) * 60) + "秒";
    } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
      time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
        parseInt(time / 3600.0)) * 60) + "分" +
        parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
          parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
    } else if (time >= 60 * 60 * 24) {
      time = parseInt(time / 3600.0 / 24) + "天" + parseInt((parseFloat(time / 3600.0 / 24) -
        parseInt(time / 3600.0 / 24)) * 24) + "时" + parseInt((parseFloat(time / 3600.0) -
        parseInt(time / 3600.0)) * 60) + "分" +
        parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
          parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
    } else {
      time = parseInt(time) + "秒";
    }
  }
  if (time === 0) time += " 秒"
  return time;
};

export const timeToYYYYMMdd = (time) => {
  if (time == "--") return time;
  var newDate = new Date(time);
  Date.prototype.format = function (format) {
    var date = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "h+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      "S+": this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
      }
    }
    return format;
  };
  return newDate.format('yyyy-MM-dd');
};


export const timeToYYYYMM = (time) => {
  if (time == "--") return time;
  var newDate = new Date(time);
  Date.prototype.format = function (format) {
    var date = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "h+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      "S+": this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
      }
    }
    return format;
  };
  return newDate.format('yyyy-MM');
};

export const date2str = (x, y) => {
  let z = {
    y: x.getFullYear(),
    M: x.getMonth() + 1,
    d: x.getDate(),
    h: x.getHours(),
    m: x.getMinutes(),
    s: x.getSeconds()
  };
  return y.replace(/(y+|M+|d+|h+|m+|s+)/g, function (v) {
    return ((v.length > 1 ? "0" : "") + eval('z.' + v.slice(-1))).slice(-(v.length > 2 ? v.length : 2))
  });
};

export const timeToYYYYMMddhhmmss = (time, format) => {
  if (time == "--") return time;
  var newDate = new Date(time);
  Date.prototype.format = function (format) {
    var date = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "h+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      "S+": this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
      }
    }
    return format;
  };
  if (!format) {
    format = "yyyy-MM-dd hh:mm:ss";
  }
  return newDate.format(format);
};


export const timeTohhmmss = (time, format) => {
  if (time == "--") return time;
  var newDate = new Date(time);
  Date.prototype.format = function (format) {
    var date = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "h+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      "S+": this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in date) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
      }
    }
    return format;
  };
  if (!format) {
    format = "hh:mm:ss";
  }
  return newDate.format(format);
};

export const timeFn = (timeText) => {
  let dateEnd = new Date();//获取当前时间
  let newFront = new Date(timeText);
  let dateDiff = dateEnd.getTime() - newFront.getTime();//时间差的毫秒数
  let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
  if (dayDiff > 0) {
    return dayDiff + "天";
  }
  let hourDiff = Math.floor(dateDiff / (3600 * 1000));//计算出相差小时
  if (hourDiff > 0) {
    return hourDiff + "小时";
  }
  let muiDiff = Math.floor(dateDiff / (60 * 1000));//计算出相差小时
  if (muiDiff > 0) {
    return muiDiff + "分钟";
  }
  return "1分钟";
}

export const getCurrentDate = () => {
  let currentDate = new Date();
  let year = currentDate.getFullYear().toString();
  let month = (currentDate.getMonth() + 1).toString();
  if (month.length === 1) {
    month = "0" + month;
  }
  let date = currentDate.getDate().toString();
  if (date.length === 1) {
    date = "0" + date;
  }
  return year + "-" + month + "-" + date;
}

export const getTaskStatusText = (disabled, status) => {
  let HTML = ``;
  if (disabled == 0) {
    HTML += `<span style="border:1px solid #999494;border-radius: 3px;color:#999494;" i18n="i18n.yunocean.commcon.ysx">已失效</span>`;
  } else {
    if (status == 0) {
      HTML += `<span style="border:1px solid #F00;border-radius: 3px;color:#F00;" i18n="i18n.yunocean.sys.yizanting.title">已暂停</span>`;
    } else if (status == 1) {
      HTML += `<span style="border:1px solid #38a1e1;border-radius: 3px;color:#38a1e1;" i18n="i18n.yunocean.sys.new.title">新任务</span>`;
    } else if (status == 2) {
      HTML += `<span style="border:1px solid #01702b;border-radius: 3px;color:#01702b;" i18n="i18n.yunocean.commcon.jinxing.title">进行中</span>`;
    } else if (status == 3) {
      HTML += `<span style="border:1px solid #F00;border-radius: 3px;color:#F00;" i18n="i18n.yunocean.task.bzbd">不在拨打时段</span>`;
    } else if (status == 10) {
      HTML += `<span style="border:1px solid #16a7ff;border-radius: 3px;color:#16a7ff;" i18n="i18n.yunocean.sys.yiwanc.title">已完成</span>`;
    }
  }
  return HTML;
};

export const openAlert = (that, title, text, callback) => {
  that.colorAlert = 'primary';
  that.$vs.dialog({
    color: that.colorAlert,
    title: title,
    text: text,
    accept: callback,
    acceptText: "确定"
  });
};

export const openDangerAlert = (that, title, text, callback, confirm) => {
  that.colorAlert = 'danger';
  that.$vs.dialog({
    color: that.colorAlert,
    title: title,
    text: text,
    accept: callback,
    acceptText: confirm ? confirm : "确定"
  });
};

export const openSuccessAlert = (that, title, text) => {
  that.$vs.dialog({
    color: 'success',
    title: title,
    text: text,
    acceptText: "确定"
  });
};

export const getEnumsTextByValue = (value, enumsObj, i18n) => {
  // 字段不存在返回‘’
  if (value === undefined || value === null) {
    return ''
  }
  for (let i in enumsObj) {
    let e = enumsObj[i]
    if (e && e.value === value) {
      if (i18n && i18n == 'en') {
        return e.entext;
      } else {
        return e.text
      }
    }
  }
};

export const getListNameById = (id, listObj) => {
  // 字段不存在返回‘’
  if (id === undefined || id === null) {
    return ''
  }
  for (let i in listObj) {
    let e = listObj[i]
    if (e && e.id === id) {
      return e.name
    }
  }
};

export const getNameByArrayId = (ids, listObj) => {
  // 字段不存在返回‘’
  if (ids === undefined || ids === null) {
    return ''
  }
  let retD = ''
  for (let m in ids) {
    for (let i in listObj) {
      let e = listObj[i]
      if (e && e.id === ids[m]) {
        retD += e.name + ','
      }
    }
  }
  return retD
};

export const getNameByKey = (ids, listObj) => {
  // 字段不存在返回‘’
  if (ids === undefined || ids === null) {
    return ''
  }
  let retD = ''
  for (let i in listObj) {
    let e = listObj[i]
    if (e && e.key === ids) {
      return e.name;
    }
  }

  return retD
};


export const getNickNameByArrayId = (id, listObj) => {
  // 字段不存在返回‘’
  if (id === undefined || id === null) {
    return ''
  }
  for (let i in listObj) {
    let e = listObj[i]
    if (e && e.id === id) {
      return e.nickname
    }
  }
};

export const getNamesByKeys = (keys, list) => {
  // 检查 keys 是否为空（null、undefined 或空数组）
  if (!keys || !Array.isArray(keys) || keys.length === 0) {
    return '';
  }

  // 检查 list 是否为空（null、undefined 或空数组）
  if (!list || !Array.isArray(list) || list.length === 0) {
    return '';
  }

  // 创建一个映射对象，便于通过 key 查找 name
  const nameMap = {};
  list.forEach(item => {
    // 使用模板字面符确保 key 是字符串类型
    nameMap[`${item.key}`] = item.name;
  });

  // 根据 keys 数组取出对应的 name，并组成数组
  const names = keys.map(key => nameMap[key]).filter(name => name !== undefined);

  // 将名字数组连接成字符串，用逗号分隔
  return names.join(', ');
};

export const getTextByArrayId = (ids, listObj) => {
  // 字段不存在返回‘’
  if (ids === undefined || ids === null) {
    return ''
  }
  let retD = ''
  for (let m in ids) {
    for (let i in listObj) {
      let e = listObj[i]
      if (e && e.value === ids[m]) {
        retD += e.text + ','
      }
    }
  }
  return retD
};

export const getIgTextByArrayId = (ids, listObj) => {
  // 字段不存在返回‘’
  if (ids === undefined || ids === null) {
    return ''
  }
  let retD = ''
  for (let m in ids) {
    for (let i in listObj) {
      let e = listObj[i]
      if (e && e.value == ids[m]) {
        retD += e.text + ','
        return retD;
      }
    }
  }
  return ids
};

export const getItemById = (id, listObj) => {
  // 字段不存在返回‘’
  if (id === undefined || id === null) {
    return ''
  }
  for (let i in listObj) {
    let e = listObj[i]
    if (e && e.id === id) {
      return e
    }
  }
};

export const getEnumsValueByText = (text, enumsObj) => {
  // 字段不存在返回‘’
  if (text === undefined || text === null) {
    return 0
  }
  for (let i in enumsObj) {
    let e = enumsObj[i]
    if (e && e.text === text) {
      return e.value
    }
  }
};

export const UF = (value) => {
  // 字段不存在返回‘’
  if (typeof (value) == undefined || value === undefined || value === null) {
    return '';
  }
  return value;
};

export const getTextByIds = (ids, items) => {
  // 字段不存在返回‘’
  if (ids === undefined || ids === null) {
    return 0
  }
  let result = '';
  for (let id in ids) {
    for (let i in items) {
      let e = items[i];
      if (e && e.id === ids[id]) {
        result += e.name + ",";
      }
    }
  }
  return result;
};

export const checkPhone = (phone) => {
  if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
    return false;
  }
  return true;
};

export const checkUrl = (url) => {
  let str = url;
  //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
  //下面的代码中应用了转义字符"\"输出一个字符"/"
  let Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
  let objExp = new RegExp(Expression);
  if (objExp.test(str) == true) {
    return true;
  } else {
    return false;
  }
};


export const checkUsername = (phone) => {
  if (!(/[^\w\/]/ig.test(phone))) {
    return false;
  }
  return true;
};

export const checkMultUsername = (username) => {
  if (!username) return false;

  // 按英文逗号 , 或中文逗号 ， 分割
  const names = username.split(/[,，]/).map(n => n.trim()).filter(Boolean);

  if (names.length === 0) return false;

  // 检查每个名字
  for (let name of names) {
    // 长度不能小于 6
    if (name.length < 6) return false;

    // 只能是字母、数字、下划线、斜杠
    if (!/^[\w\/]+$/.test(name)) return false;
  }

  return true;
};

//校验身份证的合法性
export const validateIdCard = (idCard) => {
  var vcity = {
    11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古",
    21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏",
    33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南",
    42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆",
    51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃",
    63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外"
  };
  //是否为空
  if (idCard === '') {
    return false;
  }
  //校验长度，类型
  if (isCardNo(idCard) === false) {
    return false;
  }
  //检查省份
  if (checkProvince(idCard, vcity) === false) {
    return false;
  }
  //校验生日
  if (checkBirthday(idCard) === false) {
    return false;
  }
  //检验位的检测
  if (checkParity(idCard) === false) {
    return false;
  }
  return true;
};


export const isCardNo = (card) => {
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
  var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
  if (reg.test(card) === false) {
    return false;
  }
  return true;
};

export const checkProvince = (card, vcity) => {
  var province = card.substr(0, 2);
  if (vcity[province] == undefined) {
    return false;
  }
  return true;
};

export const checkBirthday = (card) => {
  var len = card.length;
  //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
  if (len == '15') {
    var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
    var arr_data = card.match(re_fifteen);
    var year = arr_data[2];
    var month = arr_data[3];
    var day = arr_data[4];
    var birthday = new Date('19' + year + '/' + month + '/' + day);
    return verifyBirthday('19' + year, month, day, birthday);
  }
  //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
  if (len == '18') {
    var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/;
    var arr_data = card.match(re_eighteen);
    var year = arr_data[2];
    var month = arr_data[3];
    var day = arr_data[4];
    var birthday = new Date(year + '/' + month + '/' + day);
    return verifyBirthday(year, month, day, birthday);
  }
  return false;
};

export const verifyBirthday = (year, month, day, birthday) => {
  var now = new Date();
  var now_year = now.getFullYear();
  //年月日是否合理
  if (birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day) {
    //判断年份的范围（0岁到100岁之间)
    var time = now_year - year;
    if (time >= 0 && time <= 100) {
      return true;
    }
    return false;
  }
  return false;
};

export const checkParity = (card) => {
  //15位转18位
  card = changeFivteenToEighteen(card);
  var len = card.length;
  if (len == '18') {
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
    var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
    var cardTemp = 0, i, valnum;
    for (i = 0; i < 17; i++) {
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    valnum = arrCh[cardTemp % 11];
    if (valnum == card.substr(17, 1).toLocaleUpperCase()) {
      return true;
    }
    return false;
  }
  return false;
};

export const changeFivteenToEighteen = (card) => {
  if (card.length == '15') {
    var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
    var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
    var cardTemp = 0, i;
    card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
    for (i = 0; i < 17; i++) {
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    card += arrCh[cardTemp % 11];
    return card;
  }
  return card;
};


export const cutText = (text) => {
  let index = text.indexOf("-");
  if (index > 0) {
    return text.substring(0, index);
  }
  return text;
};

export const getAttachContent = (self, curSelectItem) => {
  if (curSelectItem.status == 1) {
    return "尊敬的客户" + curSelectItem.buyerName + ",您的贷款申请已于" + timeToYYYYMMddhhmmss(new Date().getTime()) + "，交" +
      cutText(curSelectItem.loanBankName) + "审批，申请" + (curSelectItem.bloanAmount ? "商贷金额" + (curSelectItem.bloanAmount / 10000).toFixed(2) + '万 ' : '') +
      (curSelectItem.gloanAmount ? "公积金" + (curSelectItem.gloanAmount / 10000).toFixed(2) + '万 ' : '') + "申请年限：" + (curSelectItem.loanYears ? curSelectItem.loanYears : '--') + "，还款方式：" +
      getEnumsTextByValue(curSelectItem.repaymentType, self.repaymentTypeEmus) + "。";
  } else if (curSelectItem.status == 2) {
    return "尊敬的客户" + curSelectItem.buyerName + "，您在" + cutText(curSelectItem.loanBankName) + "的" + (curSelectItem.bloanAmount ? "商贷金额" + (curSelectItem.bloanAmount / 10000).toFixed(2) + '万 ' : '') +
      (curSelectItem.gloanAmount ? "公积金" + (curSelectItem.gloanAmount / 10000).toFixed(2) + '万 ' : '') + "已审批通过，年限：" + (curSelectItem.loanYears ? curSelectItem.loanYears : '--') + "，利率：" +
      (curSelectItem.loanRate ? curSelectItem.loanRate : '--') + "，网签价格：" + (curSelectItem.netSignPrice ? curSelectItem.netSignPrice : '--') +
      "。请提供转款凭条：" + (curSelectItem.transferReceipt ? curSelectItem.transferReceipt : '--') + "（注需显示：实时到账；买卖双方名字和账号）。【成都鑫瑞恒生担保】请过户后领新产权证办理抵押时请提前联系：" +
      (curSelectItem.warranterName ? curSelectItem.warranterName : '--') + "。备注：" + (curSelectItem.remark ? curSelectItem.remark : '');
  } else if (curSelectItem.status == 3) {
    return "尊敬的客户" + curSelectItem.buyerName + "，您的贷款申请已于" + timeToYYYYMMddhhmmss(new Date().getTime()) + "办理抵押登记，待银行放款。备注：" + (curSelectItem.remark ? curSelectItem.remark : '');
  } else if (curSelectItem.status == 4) {
    let extendData = '';
    if (curSelectItem.usergroupExtendData) {
      extendData = ", 工作日内请携带本人身份证原件领取产权证，地址：" + curSelectItem.usergroupExtendData;
    }
    return "尊敬的客户" + curSelectItem.buyerName + "，您的贷款已于" + timeToYYYYMMddhhmmss(new Date().getTime()) + "放款完成。备注：" + (curSelectItem.remark ? curSelectItem.remark : '') + extendData;
  }
};

export const getWeixinPushContent = (self, curSelectItem, content) => {
  if (curSelectItem.status == 1) {
    return "尊敬的客户您好！您的贷款申请我公司已于" + timeToYYYYMMddhhmmss(new Date().getTime()) + "受理，请及时补充以下资料：" + content;
  } else if (curSelectItem.status == 2) {
    return "尊敬的客户" + curSelectItem.buyerName + ",您的贷款申请已于" + timeToYYYYMMddhhmmss(new Date().getTime()) + "，交" +
      cutText(curSelectItem.loanBankName) + "审批，申请" + (curSelectItem.bloanAmount ? "商贷金额" + (curSelectItem.bloanAmount / 10000).toFixed(2) + '万 ' : '') +
      (curSelectItem.gloanAmount ? "公积金" + (curSelectItem.gloanAmount / 10000).toFixed(2) + '万 ' : '') + "申请年限：" + (curSelectItem.loanYears ? curSelectItem.loanYears : '--') + "，还款方式：" +
      getEnumsTextByValue(curSelectItem.repaymentType, self.repaymentTypeEmus) + "。";
  } else if (curSelectItem.status == 3) {
    return "尊敬的客户" + curSelectItem.buyerName + "，您在" + cutText(curSelectItem.loanBankName) + "的" + (curSelectItem.bloanAmount ? "商贷金额" + (curSelectItem.bloanAmount / 10000).toFixed(2) + '万 ' : '') +
      (curSelectItem.gloanAmount ? "公积金" + (curSelectItem.gloanAmount / 10000).toFixed(2) + '万 ' : '') + "已审批通过，年限：" + (curSelectItem.loanYears ? curSelectItem.loanYears : '--') + "，利率：" +
      (curSelectItem.loanRate ? curSelectItem.loanRate : '--') + "，网签价格：" + (curSelectItem.netSignPrice ? curSelectItem.netSignPrice : '--') +
      "。请提供转款凭条：" + (curSelectItem.transferReceipt ? curSelectItem.transferReceipt : '--') + "（注需显示：实时到账；买卖双方名字和账号）。【成都鑫瑞恒生担保】请过户后领新产权证办理抵押时请提前联系：" +
      (curSelectItem.warranterName ? curSelectItem.warranterName : '--') + "。备注：" + (curSelectItem.remark ? curSelectItem.remark : '');
  } else if (curSelectItem.status == 4) {
    return "尊敬的客户" + curSelectItem.buyerName + "，您的贷款申请已于" + timeToYYYYMMddhhmmss(new Date().getTime()) + "办理抵押登记，待银行放款。备注：" + (curSelectItem.remark ? curSelectItem.remark : '');
  } else if (curSelectItem.status == 5) {
    let extendData = '';
    if (curSelectItem.usergroupExtendData) {
      extendData = ", 工作日内请携带本人身份证原件领取产权证，地址：" + curSelectItem.usergroupExtendData;
    }
    return "尊敬的客户" + curSelectItem.buyerName + "，您的贷款已于" + timeToYYYYMMddhhmmss(new Date().getTime()) + "放款完成。备注：" + (curSelectItem.remark ? curSelectItem.remark : '') + extendData;
  }
}

export const getCookie = (key) => {
  let arr, reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

export const setCookie = (name, value, day) => {
  let exp = new Date();
  exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ((day == null) ? "" : ";path=/;expires=" + exdate.toGMTString());
}

export const delCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = this.getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";path=/;expires=" + exp.toGMTString();
}

export const transfertEnter = (content) => {
  let string = content;
  try {
    string = string.replace(/\r\n/g, "")
    string = string.replace(/\n/g, "");
  } catch (e) {
  }
  return string;
}

export const notifySuccess = (that, title, text) => {
  that.$vs.notify({
    color: 'success',
    title: title,
    text: text
  })
};

export const notifyDanger = (that, title, text) => {
  that.$vs.notify({
    color: 'danger',
    title: title,
    text: text
  })
};

export const splitIgnoreString = (text) => {
  let curlyBraceCounter = 0; // 记录花括号 {}
  let squareBracketCounter = 0; // 记录方括号 []
  let keysList = [];
  let buffer = '';

  for (let i = 0; i < text.length; i++) {
    let c = text[i];

    // 更新计数器
    if (c === '{') {
      curlyBraceCounter++;
    } else if (c === '}') {
      curlyBraceCounter--;
    } else if (c === '[') {
      squareBracketCounter++;
    } else if (c === ']') {
      squareBracketCounter--;
    }

    // 判断分割条件：不在任何括号内
    if (c === ',' && curlyBraceCounter === 0 && squareBracketCounter === 0) {
      keysList.push(buffer.trim()); // 去除两端空格
      buffer = '';
    } else {
      buffer += c;
    }
  }

  // 添加最后一个片段
  if (buffer.length > 0) {
    keysList.push(buffer.trim());
  }

  return keysList;
};


export const formatChatConversationAction = (items) => {
  let formatChatConversation = [];
  if (items && items.length > 0) {
    let talkMessage = "";
    let talkUrlArray = [];
    let index = 1;
    let inserttime = "";

    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      const nextItem = items[i + 1];

      // 普通类型直接推入
      if (item.khtype == 0 || item.khtype == 3 || item.khtype == 9) {
        formatChatConversation.push(item);
        continue;
      }

      // 处理 khtype == 1 或 5
      if (item.khtype == 1 || item.khtype == 5) {
        if (item.loseFlag == 0) {
          talkMessage += item.khcontent;
          inserttime = item.inserttime;
          talkUrlArray.push(item.khvoicepath);
        }

        // 判断是否到该段的结束（下一个类型不同或已经是最后一个）
        const isLastInGroup =
          !nextItem || nextItem.khtype !== item.khtype;

        if (isLastInGroup) {
          talkMessage += "。";
          let tmpItem = {
            id: "N" + index,
            khcontent: talkMessage,
            khtype: item.khtype,
            loseFlag: 0,
            reduceNoiseRate: 0,
            talkUrlArray: talkUrlArray,
            inserttime: inserttime,
            playing: false,
          };
          formatChatConversation.push(tmpItem);
          index++;
          talkMessage = "";
          talkUrlArray = [];
        } else {
          // 同一段内，继续拼接
          if (item.loseFlag == 0) {
            talkMessage += "，";
          }
        }
      }
    }
  }

  console.log("-------------------------------");
  console.log(formatChatConversation);
  return formatChatConversation;
};


export const isValidIPv4 = (ipWithCIDR) => {
  // 使用正则表达式检查 IPv4 地址和 CIDR 格式
  const ipv4CIDRRegex = /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})(\/([0-8]|1[0-9]|2[0-9]|3[0-2]))?$/;
  if (!ipv4CIDRRegex.test(ipWithCIDR)) {
    return false; // 如果 IPv4 地址和 CIDR 格式不正确，则返回 false
  }

  // 分割 IPv4 地址和掩码长度
  const [ip, cidr] = ipWithCIDR.split('/');

  // 如果 CIDR 不存在，则返回 true
  if (cidr === undefined) {
    return true;
  }

  // 分割 IPv4 地址为数组
  const ipParts = ip.split('.');

  // 检查每个部分是否在有效范围内
  for (let i = 0; i < 4; i++) {
    if (parseInt(ipParts[i]) < 0 || parseInt(ipParts[i]) > 255) {
      return false; // 如果 IPv4 地址不在有效范围内，则返回 false
    }
  }

  // 检查 CIDR 是否在有效范围内
  const cidrValue = parseInt(cidr);
  // if (cidrValue != 8 && cidrValue != 16 && cidrValue != 24) {
  //   return false; // 如果 CIDR 不在有效范围内，则返回 false
  // }

  if (cidrValue <= 0 && cidrValue > 32) {
    return false; // 如果 CIDR 不在有效范围内，则返回 false
  }

  return true; // 如果 IPv4 地址和 CIDR 有效，则返回 true
}


export const addMinutes = (time, minutes) => {
// 解析输入的时间字符串
  let [hours, mins] = time.split(':').map(Number);

  // 创建一个日期对象
  let date = new Date();
  date.setHours(hours);
  date.setMinutes(mins + minutes);

  // 获取新的小时和分钟
  let newHours = date.getHours();
  let newMinutes = date.getMinutes();

  // 格式化时间为两位数
  newHours = newHours < 10 ? '0' + newHours : newHours;
  newMinutes = newMinutes < 10 ? '0' + newMinutes : newMinutes;

  // 返回新的时间字符串
  return `${newHours}:${newMinutes}`;
}

export const formatBalanceText = (balance) => {
  if (balance === '' || isNaN(balance)) {
    return '';
  }
  const value = parseFloat(balance);
  if (value >= 100000000) {
    return (value / 100000000).toFixed(2) + ' 万元';
  } else {
    return (value / 10000).toFixed(2) + ' 元';
  }
};

export const matchAnyRegex = (branchKeys, testText) => {
  var resultList = [];
  var hasMatched = false;

  if (!branchKeys || !branchKeys.length || !testText) {
    return {
      hasMatched: false,
      status: '未通过',
      results: []
    };
  }

  for (var i = 0; i < branchKeys.length; i++) {
    var item = branchKeys[i];
    var matched = false;

    try {
      var reg = item instanceof RegExp
        ? item
        : new RegExp(item);

      matched = reg.test(testText);
    } catch (e) {
      matched = false;
    }

    if (matched) {
      hasMatched = true;
    }

    resultList.push({
      regex: item,
      matched: matched,
      text: matched ? '匹配成功' : '匹配失败'
    });
  }

  return {
    hasMatched: hasMatched,
    status: hasMatched ? '通过' : '未通过',
    results: resultList
  };
};

export const formatTimeAgo = (time) => {
  if (!time) return '--';

  const now = Date.now();
  const diff = now - time;

  // 防止时间异常（未来时间）
  if (diff < 0) return '刚刚';

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;

  if (diff < minute) {
    return '刚刚'
  } else if (diff < hour) {
    return `${Math.floor(diff / minute)} 分钟前`
  } else if (diff < day) {
    return `${Math.floor(diff / hour)} 小时前`
  } else {
    return `${Math.floor(diff / day)} 天前`
  }
};

export const getTimeAgoClass = (time) => {
  if (!time) return 'time-gray';

  const diff = Date.now() - time;
  const hour = 60 * 60 * 1000;
  const day = 24 * hour;

  if (diff < hour) {
    return 'time-green'     // 1小时内：在线感强
  } else if (diff < day) {
    return 'time-orange'    // 1天内：正常
  } else {
    return 'time-red'       // 超过1天：不活跃
  }
};






// WEBPACK FOOTER //
// ./src/utils/tools.js